import { useEffect, useState } from "react";
import Confetti from "react-confetti";

export default function Celebration({ active }) {
  const [size, setSize] = useState({ w: 0, h: 0 });

  useEffect(() => {
    const update = () =>
      setSize({ w: window.innerWidth, h: window.innerHeight });
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  if (!active || !size.w) return null;

  return (
    <div className="fixed inset-0 z-[55] pointer-events-none" data-testid="confetti-layer">
      <Confetti
        width={size.w}
        height={size.h}
        numberOfPieces={180}
        recycle={false}
        gravity={0.2}
        tweenDuration={6000}
        colors={["#E8B4B8", "#D4AF37", "#FAF7F2", "#C8B1B5"]}
      />
    </div>
  );
}
